import { render, staticRenderFns } from "./DonorLegalFormPrint.vue?vue&type=template&id=69f58817"
import script from "./DonorLegalFormPrint.vue?vue&type=script&lang=js"
export * from "./DonorLegalFormPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports